(function () {
  if (window.SorviqBuybox) return;
  window.SorviqBuybox = true;

  var lastState = '';

  // True when the order will go out as a subscription: either the built-in box is checked,
  // or the subscription app (Kaching…) has put a selling plan in the form.
  function isSubscribed(form) {
    var own = form.querySelector('[data-buy-subscribe]');
    if (own) return own.checked;
    var plan = form.querySelector('input[name="selling_plan"]');
    return !!(plan && plan.value);
  }

  function refresh(form) {
    var selected = form.querySelector('[data-bundle].is-selected');
    if (!selected) return;
    var subscribed = isSubscribed(form);
    var own = form.querySelector('[data-buy-subscribe]');

    // Variant sent to the cart (subscription apps listen to this change event).
    var idInput = form.querySelector('[data-buy-id]');
    if (idInput.value !== selected.getAttribute('data-variant-id')) {
      idInput.value = selected.getAttribute('data-variant-id');
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Built-in "Subscribe & Save" box adds the selling plan to the form itself.
    if (own) {
      var planInput = form.querySelector('input[name="selling_plan"][data-buy-plan]');
      if (subscribed) {
        if (!planInput) {
          planInput = document.createElement('input');
          planInput.type = 'hidden';
          planInput.name = 'selling_plan';
          planInput.setAttribute('data-buy-plan', '');
          form.appendChild(planInput);
        }
        planInput.value = own.value;
      } else if (planInput) {
        planInput.remove();
      }
    }

    // Every pack card shows the one-time or the subscription price.
    form.querySelectorAll('[data-bundle]').forEach(function (b) {
      var price = b.querySelector('[data-bundle-price]');
      var each = b.querySelector('[data-bundle-each]');
      if (price) price.textContent = b.getAttribute(subscribed ? 'data-sub-price' : 'data-price');
      if (each) each.textContent = b.getAttribute(subscribed ? 'data-sub-each' : 'data-each');
    });

    // Price and SAVE badge above the packs, and price in the sticky bar.
    var root = form.closest('.sorviq-lp') || document;
    var topPrice = selected.getAttribute(subscribed ? 'data-sub-price' : 'data-price');
    root.querySelectorAll('[data-buy-price]').forEach(function (el) {
      el.textContent = topPrice;
    });
    var save = Number(selected.getAttribute(subscribed ? 'data-sub-save' : 'data-save')) || 0;
    var badge = root.querySelector('[data-buy-save]');
    if (badge) {
      badge.hidden = save <= 0;
      var pct = badge.querySelector('[data-buy-save-pct]');
      if (pct) pct.textContent = save;
    }

    lastState = selected.getAttribute('data-variant-id') + '|' + subscribed;
  }

  // A subscription app enabled as an app embed drops its widget right above the form.
  // Move it into the slot under the packs.
  function placeAppWidget(form) {
    var slot = form.querySelector('[data-buy-apps]');
    var root = form.closest('.sorviq-lp');
    if (!slot || !root) return;
    root.querySelectorAll('kaching-subscriptions').forEach(function (widget) {
      if (!slot.contains(widget)) slot.appendChild(widget);
    });
  }

  function watch(form) {
    if (form.hasAttribute('data-buy-watched')) return;
    form.setAttribute('data-buy-watched', '');
    placeAppWidget(form);
    refresh(form);

    var root = form.closest('.sorviq-lp') || form.parentNode;
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        placeAppWidget(form);
      }).observe(root, { childList: true, subtree: true });
    }

    // The app changes the selling plan input without firing an event: check it regularly.
    setInterval(function () {
      var selected = form.querySelector('[data-bundle].is-selected');
      if (!selected) return;
      var state = selected.getAttribute('data-variant-id') + '|' + isSubscribed(form);
      if (state !== lastState) refresh(form);
    }, 300);
  }

  function init() {
    document.querySelectorAll('[data-sorviq-buybox]').forEach(watch);
  }

  document.addEventListener('click', function (e) {
    var bundle = e.target.closest('.sorviq-lp [data-bundle]');
    if (!bundle || bundle.disabled) return;
    var form = bundle.closest('[data-sorviq-buybox]');
    if (!form) return;
    form.querySelectorAll('[data-bundle]').forEach(function (b) {
      var on = b === bundle;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    refresh(form);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.sorviq-lp [data-buy-subscribe]')) return;
    refresh(e.target.closest('[data-sorviq-buybox]'));
  });

  // The subscription app's sticky "Choose plan" button brings the visitor back to the packs.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.kaching-subscriptions-sticky-atc button');
      var buybox = document.getElementById('buybox');
      if (!btn || !buybox) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    true
  );

  // Keep the ad version (?d=...) on the order for attribution.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sorviq-buybox]')) return;
    var version = document.body.getAttribute('data-lp-active');
    if (!version || form.querySelector('input[name="attributes[lp_version]"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'attributes[lp_version]';
    input.value = version;
    form.appendChild(input);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
